export {
  LegalBottomSheetProvider,
  useLegalBottomSheet,
  type LegalBottomSheetContextType,
  type LegalBottomSheetProviderProps,
} from './LegalBottomSheetContext';
